import { useState, useEffect } from "react";
import AnalyticsHeader from "./components/AnalyticsHeader";
import AnalyticsTable from "./components/AnalyticsTable";
import Spinner from "../Spin/Spinner";
import { useSelector } from "react-redux";
import { getAllUsers } from "../../config/LiveApi";

const MonthlyAnalytics = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [tableData, setTableData] = useState([]);
  const [userList, setUserList] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchUsers = async () => {
    try {
      const response = await getAllUsers(token, 1);
      const data = response?.data;
      const adminUsers = data?.filter((user) => user.role === "admin");
      setUserList(adminUsers);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <AnalyticsHeader
        userList={userList}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        setTableData={setTableData}
        tableData={tableData}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      {!tableData.length && !isLoading ? (
        <div style={{ marginTop: "12rem", textAlign: "center", color: "#777" }}>
          Please select a merchant to view analytics
        </div>
      ) : isLoading ? (
        <Spinner />
      ) : (
        <AnalyticsTable
          tableData={tableData}
          setTableData={setTableData}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default MonthlyAnalytics;
